module.exports = __webpack_public_path__ + "img/icon_hotels_greyed.27e3a2c7.png";